import React, { useState } from "react";
import ExerciseIllustration from "./ExerciseIllustrations";
import { EXERCISE_LABELS, EXERCISE_EMOJIS } from "../data/constants";

/**
 * Acordeón de guías visuales de ejercicios.
 * @param {string[]} exercises - Array de IDs de ejercicio.
 * @param {object} colors - Colores del tipo de día { bg, text, dot }.
 */
export default function ExerciseGuide({ exercises, colors }) {
  const [openExercise, setOpenExercise] = useState(null);

  if (!exercises || exercises.length === 0) return null;

  const toggle = (ex) => setOpenExercise(openExercise === ex ? null : ex);

  return (
    <div style={{ marginTop: 12 }}>
      <div
        style={{
          fontSize: 11,
          fontWeight: 700,
          color: colors.text,
          marginBottom: 8,
          textTransform: "uppercase",
          letterSpacing: 1.5,
        }}
      >
        📐 Guía visual de ejercicios
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        {exercises.map((ex) => {
          const isOpen = openExercise === ex;

          return (
            <div key={ex}>
              {/* Botón del ejercicio */}
              <button
                onClick={() => toggle(ex)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  width: "100%",
                  padding: "8px 12px",
                  borderRadius: 10,
                  border: `1.5px solid ${isOpen ? colors.dot : "var(--border-color, #E5E7EB)"}`,
                  background: isOpen ? colors.bg : "var(--bg-color, #fff)",
                  cursor: "pointer",
                  fontSize: 12,
                  fontWeight: 600,
                  color: colors.text,
                  transition: "all 0.2s ease",
                  fontFamily: "Outfit, sans-serif",
                }}
              >
                <span style={{ fontSize: 14 }}>{EXERCISE_EMOJIS[ex]}</span>
                {EXERCISE_LABELS[ex]}
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke={colors.text}
                  strokeWidth="2"
                  strokeLinecap="round"
                  style={{
                    marginLeft: "auto",
                    transform: isOpen ? "rotate(180deg)" : "rotate(0)",
                    transition: "transform 0.2s",
                  }}
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </button>

              {/* Ilustración expandida */}
              {isOpen && (
                <div
                  className="fade-in"
                  style={{
                    marginTop: 6,
                    padding: 12,
                    background: "var(--bg-color, #FAFAFA)",
                    borderRadius: 12,
                    border: `1px solid ${colors.dot}33`,
                    overflowX: "auto",
                  }}
                >
                  <ExerciseIllustration type={ex} />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
